<p-toast></p-toast>
<div class="app-verification-container mt-2">
    <p-card styleClass="p-card-shadow">
        <div class="card dashboardTable">
            <p-toolbar styleClass="mb-4" reflow="true">
                <ng-template pTemplate="left">
                    <button pButton pRipple label="{{'ADD_OVERFLOW_POND'| translate}}" icon="pi pi-plus"
                        class="p-button-success mr-2" (click)="addCanalDetails()"></button>
                </ng-template>

                <ng-template pTemplate="right">
                    <button *ngIf="overFlowPondMasterData.length>0" (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT' | translate}}"
                        icon="pi pi-upload" class="p-button-help"></button>
                        <p-menu #menu [popup]="true" [model]="menuItems"></p-menu>
                    <button (click)="refreshTable()" pButton pRipple label="{{'REFRESH'| translate}}" icon="pi pi-refresh"
                        class="p-button-info ml-3"></button>
                </ng-template>
            </p-toolbar>
            <p-table #overFlowPondTable [loading]="loading" [value]="overFlowPondMasterData" [paginator]="true" [globalFilterFields]="[
                    'TotalApps',
                    'District',
                    'Village',
                    'Constituency',
                    'Name',
                    'documentID',
                    'DocumentPath',
                    'CurrentStatus',
                    'Created_Date',
                    'Updated_Date',
                    'endDate',
                    'fromDate',
                    'AreaAcre',
                    'CCA',
                    'Block'
                    ]" responsiveLayout="scroll" [rowHover]="true"
                currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                [showCurrentPageReport]="true" [paginator]="true" [rows]="10" [selectionPageOnly]="true"
                [rowsPerPageOptions]="[10,25,50,100]" >
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <h5 class="m-0">{{'OVERFLOW_POND_BASED'| translate}}</h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text"
                                (input)="overFlowPondTable.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="{{'SEARCH'| translate}}" />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header" class="tableHeader">
                    <tr>
                        <th pSortableColumn="TotalApps">{{'TOTAL_APPLICATIONS'| translate}}
                            <p-columnFilter type="text" field="TotalApps" display="menu"></p-columnFilter>
                            <p-sortIcon field="TotalApps"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Constituency">{{'CONSTITUENCY'| translate}}
                            <p-columnFilter type="text" field="Constituency" display="menu"></p-columnFilter>
                            <p-sortIcon field="Constituency"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Block">{{'BLOCK'| translate}}
                            <p-columnFilter type="text" field="Block" display="menu"></p-columnFilter>
                            <p-sortIcon field="Block"></p-sortIcon>
                        </th>
                        <th pSortableColumn="District">{{'DISTRICT'| translate}}
                            <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                            <p-sortIcon field="District"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Village">{{'VILLAGE'| translate}}
                            <p-columnFilter type="text" field="Village" display="menu"></p-columnFilter>
                            <p-sortIcon field="Village"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Name">{{'OVERFLOW_POND_NAME'| translate}}
                            <p-columnFilter type="text" field="Name" display="menu"></p-columnFilter>
                            <p-sortIcon field="Name"></p-sortIcon>
                        </th>
                        <th pSortableColumn="CCA">{{'CCA'| translate}}
                            <p-columnFilter type="text" field="CCA" display="menu"></p-columnFilter>
                            <p-sortIcon field="CCA"></p-sortIcon>
                        </th>
                        <th pSortableColumn="AreaAcre">{{'TARGET_AREA'| translate}}
                            <p-columnFilter type="text" field="AreaAcre" display="menu"></p-columnFilter>
                            <p-sortIcon field="AreaAcre"></p-sortIcon>
                        </th>
                        <th pSortableColumn="documentID">{{'OFFICE_ORDER_NO'| translate}}
                            <p-columnFilter type="text" field="documentID" display="menu"></p-columnFilter>
                            <p-sortIcon field="documentID"></p-sortIcon>
                        </th>
                        <th pSortableColumn="documentPath">{{'VIEW_OFFICE_ORDER_COPY'| translate}}
                            <p-columnFilter type="text" field="documentPath" display="menu"></p-columnFilter>
                            <p-sortIcon field="documentPath"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Created_Date">{{'CREATED_DATE'| translate}}
                            <p-columnFilter type="text" field="Created_Date" display="menu"></p-columnFilter>
                            <p-sortIcon field="Created_Date"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Updated_Date">{{'UPDATED_DATE'| translate}}
                            <p-columnFilter type="text" field="Updated_Date" display="menu"></p-columnFilter>
                            <p-sortIcon field="Updated_Date"></p-sortIcon>
                        </th>
                        <th pSortableColumn="fromDate">{{'START_DATE'| translate}}
                            <p-columnFilter type="text" field="fromDate" display="menu"></p-columnFilter>
                            <p-sortIcon field="fromDate"></p-sortIcon>
                        </th>
                        <th pSortableColumn="endDate">{{'END_DATE'| translate}}
                            <p-columnFilter type="text" field="endDate" display="menu"></p-columnFilter>
                            <p-sortIcon field="endDate"></p-sortIcon>
                        </th>
                        <th pSortableColumn="CurrentStatus">{{'CURRENT_STATUS'| translate}}
                            <p-columnFilter type="text" field="CurrentStatus" display="menu"></p-columnFilter>
                            <p-sortIcon field="CurrentStatus"></p-sortIcon>
                        </th>
                        <th pSortableColumn="">{{'ACTION'| translate}} </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <tr>
                        <td>{{product?.TotalApps}}</td>
                        <td>{{product?.Constituency}}</td>
                        <td>{{product?.Block}}</td>
                        <td>{{product?.District}}</td>
                        <td>{{product?.Village}}</td>
                        <td>{{product?.Name}}</td>
                        <td>{{product?.CCA}}</td>
                        <td>{{product?.AreaAcre}}</td>
                        <td>{{product?.documentId}}</td>
                        <td><a *ngIf="product?.DocumentPath" style="cursor: pointer" [href]="product?.DocumentPath"
                            target="_blank">{{'VIEW_DOC' | translate}}</a></td>
                        <td>{{product?.Created_Date | date:'mediumDate'}}</td>
                        <td>{{product?.Updated_Date | date:'mediumDate'}}</td>
                        <td>{{product?.fromDate | date:'mediumDate' }}</td>
                        <td>{{product?.endDate | date:'mediumDate'}}</td>
                        <td>
                            <button *ngIf="product?.CurrentStatus == 'Open'" pButton pRipple type="button"
                                class="p-button-rounded p-button-success" label="{{ product?.CurrentStatus }}"></button>
                            <button *ngIf="product?.CurrentStatus == 'Close'" pButton pRipple type="button"
                                class="p-button-rounded p-button-danger" label="{{ product?.CurrentStatus }}"></button>
                        </td>
                        <td>
                            <button *ngIf="product?.CurrentStatus == 'Close'" pButton pRipple type="button" pTooltip=""
                                (click)="updateAction(product)" icon="pi pi-pencil" class="p-button-rounded"></button>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="flex align-items-center justify-content-between">
                        {{'IN_TOTAL_THERE_ARE'| translate}} {{overFlowPondMasterData ? overFlowPondMasterData.length : 0 }}
                        {{'OVERFLOW_POND_BASED'| translate}}
                    </div>
                </ng-template>
            </p-table>
        </div>
    </p-card>
</div>

<p-dialog [(visible)]="showDialogToUpdateStatus" (onHide)="hideUpdateDialog()" [style]="{width: '700px', height: '380px'}"
    header="{{ 'UPDATE_STATUS' | translate}}" [modal]="true" [baseZIndex]="-100" styleClass="p-fluid">
    <ng-template pTemplate="content">
        <form [formGroup]="updateStatusForm">
            <div class="p-fluid p-formgrid grid">
                <div class="field col-12 md:col-4">
                    <label htmlFor="documentID">{{'OFFICE_ORDER_NO' | translate}}</label>
                    <input formControlName="documentID" pInputText id="documentID" type="text"
                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && updateStatusFormControls.documentID.errors }" />

                    <div *ngIf="isSubmitted && updateStatusFormControls.documentID.errors" class="invalid-feedback">
                        <div *ngIf="updateStatusFormControls.documentID.errors.required">{{'DOCUMENT_NUMBER_IS_REQUIRED'
                            |
                            translate}}
                        </div>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label htmlFor="block">{{'START_DATE' | translate}}</label>
                    <p-calendar appendTo="body" [showIcon]="true" [showButtonBar]="true" dateFormat="dd-mm-yy"
                        formControlName="fromDate"
                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && updateStatusFormControls.fromDate.errors }"></p-calendar>
                    <div *ngIf="isSubmitted && updateStatusFormControls.fromDate.errors" class="invalid-feedback">
                        <div *ngIf="updateStatusFormControls.fromDate.errors.required">{{'START_DATE_IS_REQUIRED' |
                            translate}}
                        </div>
                    </div>
                </div>

                <div class="field col-12 md:col-4">
                    <label htmlFor="block">{{'END_DATE' | translate}}</label>
                    <p-calendar appendTo="body" [showIcon]="true" [showButtonBar]="true" dateFormat="dd-mm-yy"
                        formControlName="endDate"
                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && updateStatusFormControls.endDate.errors }"></p-calendar>
                    <div *ngIf="isSubmitted && updateStatusFormControls.endDate.errors" class="invalid-feedback">
                        <div *ngIf="updateStatusFormControls.endDate.errors.required">{{'END_DATE_IS_REQUIRED' |
                            translate}}
                        </div>
                    </div>
                </div>

                <div class="field col-12 md:col-4">
                    <label htmlFor="area">{{'TARGET_AREA' | translate}}</label>
                    <input formControlName="area" pInputText id="area" type="number" min="0"
                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && updateStatusFormControls.documentID.errors }" />
                    <div *ngIf="isSubmitted && updateStatusFormControls.area.errors" class="invalid-feedback">
                        <div *ngIf="updateStatusFormControls.area.errors.required">{{'AREA_IS_REQUIRED' |
                            translate}}
                        </div>
                    </div>
                </div>

                <div class="field col-12 md:col-6">
                    <label htmlFor="documentPath">{{'UPLOAD_OFFICE_ORDER_COPY' | translate}}</label>
                    <div class="flex">
                        <p-fileUpload accept=".jpeg,.pdf,.jpg" #documentFileUpload [customUpload]="true"
                            (uploadHandler)="onUpload($event, 'documentPath', documentFileUpload)" name="myfile[]"
                            mode="basic" [maxFileSize]="5000000" chooseLabel="{{'BROWSE' | translate}}" [auto]="true">
                        </p-fileUpload>
                        <p-image *ngIf="updateStatusFormControls.documentPath.value"
                            [src]="updateStatusFormControls.documentPath.value" alt="Image" width="60"
                            class="ml-2 p-button-rounded p-button-success" iconPos="left"></p-image>
                    </div>
                    <div *ngIf="isSubmitted && updateStatusFormControls.documentPath.errors" class="invalid-feedback">
                        <div *ngIf="updateStatusFormControls.documentPath.errors.required">{{'DOCUMENT_IS_REQUIRED' |
                            translate}}</div>
                    </div>
                </div>
            </div>
        </form>
    </ng-template>

    <ng-template pTemplate="footer">
        <button pButton pRipple label="{{'CANCEL' | translate}}" icon="pi pi-times" class="p-button-text"
            (click)="hideUpdateDialog()"></button>
        <button pButton pRipple label="{{'SAVE'| translate}}" icon="pi pi-check" class="p-button-text"
            (click)="saveProduct()"></button>
    </ng-template>
</p-dialog>

<p-dialog [(visible)]="showDialogToAddCanal" (onHide)="hideAddDialog()" [style]="{width: '800px', height: '300px'}"
    header="{{ 'ADD_OVERFLOW_POND' | translate}}" [modal]="true" reflow="true" class="p-fluid" [baseZIndex]="-100"
    [draggable]="false">
    <ng-template pTemplate="content">
        <form [formGroup]="addCanalForm">
            <div class="grid p-fluid mt-3">
                <div class="field col-12 md:col-4">
                    <label htmlFor="addCanal">{{'SELECT_VILLAGE' | translate}}</label>
                    <span class="p-float-label">
                        <p-autoComplete formControlName="village" [(ngModel)]="selectedVillage"
                            placeholder="{{'SEARCH_VILLAGE' | translate}}" appendTo="body" id="dd" [dropdown]="true"
                            [multiple]="false" [suggestions]="filteredVillage" (completeMethod)="filterVillage($event)"
                            field="Name" (onSelect)="onSelectVillage()"
                            [ngClass]="{ 'ng-invalid ng-dirty': addCanalSubmitted && f.village.errors }"></p-autoComplete>

                        <div *ngIf="addCanalSubmitted && f.village.errors" class="invalid-feedback">
                            <div *ngIf="f.village.errors.required">{{'VILLAGE_IS_REQUIRED'| translate}}</div>
                        </div>
                    </span>
                </div>

                <div class="field col-12 md:col-4">
                    <label htmlFor="selectOutlet">{{'SELECT_OUTLET'| translate}}</label>
                    <span class="p-float-label">
                        <p-dropdown formControlName="outlet" [options]="outletMasterData"
                            placeholder="{{'SELECT_OUTLET'| translate}}" optionLabel="canal_RD"
                            [ngClass]="{ 'ng-invalid ng-dirty': addCanalSubmitted && f.outlet.errors }"
                            appendTo="body"></p-dropdown>

                        <div *ngIf="addCanalSubmitted && f.outlet.errors" class="invalid-feedback">
                            <div *ngIf="f.outlet.errors.required">{{'OUTLET_IS_REQUIRED'| translate}}</div>
                        </div>
                    </span>
                </div>

                <div class="field col-12 md:col-4">
                    <label htmlFor="ccaID">{{'CCA' | translate}}</label>
                    <input formControlName="cca" pInputText id="ccaID" type="text"
                    [ngClass]="{ 'ng-invalid ng-dirty': addCanalSubmitted && f.cca.errors }" />

                    <div *ngIf="addCanalSubmitted && f.cca.errors" class="invalid-feedback">
                        <div *ngIf="f.cca.errors.required">{{'CCA_IS_REQUIRED'| translate}}</div>
                    </div>
                </div>

            </div>
        </form>
    </ng-template>

    <ng-template pTemplate="footer">
        <button pButton pRipple label="{{'CANCEL'| translate}}" icon="pi pi-times" class="p-button-text"
            (click)="hideAddDialog()"></button>
        <button pButton pRipple label="{{'SAVE' | translate}}" icon="pi pi-check" class="p-button-text"
            (click)="onAddSubmit()"></button>
    </ng-template>
</p-dialog>

<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>